import type { Locale } from '@ecomm/utils/locale/types'
import { includeImage } from '../../../lib/utils'
import { getPackageMenuRightItems } from '../data'
import type { HeaderRedesignSchema } from '../schema'
import { RightSideImage } from './RightSideImage'
import { RightSideInfo } from './RightSideInfo'
import { RightSideLink } from './RightSideLink'

type PackagesRightSideProps = {
  readonly locale: Locale
  readonly images: HeaderRedesignSchema['images']
  readonly handleClick: (text: string) => () => void
}
export function PackagesRightSide({
  locale,
  images,
  handleClick
}: PackagesRightSideProps) {
  const rightSide = includeImage(getPackageMenuRightItems(locale), images)

  return (
    <div className="flex items-center border-0 border-b border-solid border-neutral-300 px-4 pb-3 pt-1 min-[1126px]:border-b-0 min-[1126px]:p-0">
      <div className="hidden min-[1126px]:flex">
        <RightSideImage image={rightSide.image} />
        <div className="ml-4 flex w-2/3 flex-wrap gap-1 min-[1126px]:w-60 min-[1270px]:ml-9">
          <RightSideInfo
            title={rightSide.title}
            description={rightSide.description}
          />
          <RightSideLink
            className="text-complementary-blue-100 block text-sm hover:no-underline min-[1126px]:text-base"
            onClick={handleClick(rightSide.title)}
            to={rightSide.url}
          >
            {rightSide.link}
          </RightSideLink>
        </div>
      </div>
      <div className="flex min-[1126px]:hidden">
        <RightSideLink
          className="text-neutral-black flex items-center no-underline"
          onClick={handleClick(rightSide.title)}
          to={rightSide.url}
        >
          <RightSideImage image={rightSide.image} />
          <div className="ml-4 flex w-2/3 flex-wrap gap-1 min-[1126px]:w-60 min-[1270px]:ml-9">
            <RightSideInfo
              title={rightSide.title}
              description={rightSide.description}
            />
            <span className="text-complementary-blue-100 block text-sm underline hover:no-underline min-[1126px]:text-base">
              {rightSide.link}
            </span>
          </div>
        </RightSideLink>
      </div>
    </div>
  )
}
